import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Unbestimmter Ladeindikator (MUI-`CircularProgress`-Ersatz). */
export const Spinner = forwardRef(function Spinner({ size = 20, label = 'Laedt', style, className, ...rest }, ref) {
    return (_jsx("span", { ref: ref, role: "status", "aria-label": label, className: cn('sec-spinner', className), style: { width: size, height: size, ...style }, ...rest }));
});
